import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomerBillingInvoiceModel } from '../customer-billing-invoice.model';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';

@Component({
    selector: 'fi-customer-billing-invoice-view',
    templateUrl: './customer-billing-invoice-view.component.html',
    styleUrls: ['./customer-billing-invoice-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-invoice-view' },
    standalone: false,
})
export class CustomerBillingInvoiceViewComponent implements OnInit {
    @Input() invoice: CustomerBillingInvoiceModel;
    EditTabs: EditTabsModel;

    constructor(
        private appTextService: AppTextService,
        private stateService: FiStateService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
    }

    private setPageHeaderData() {
        this.EditTabs = new EditTabsModel(this.getInvoiceTitle());
        this.EditTabs.Tabs.push(new EditTabModel('', ''));
    }

    private getInvoiceTitle(): string {
        return `${this.appTextService.get('common.invoice')} ${this.invoice.Id} - ${this.invoice.CustomerName}`;
    }

    editInvoice() {
        this.stateService.go(FiStateNames.CustomerBilling.Invoice.Edit, { Id: this.invoice.Id });
    }
}
